// extracted by mini-css-extract-plugin
export var subtitle = "_a5-2";
export var title = "_a5-0";
export var titleNoWrap = "_a5-1";